module.exports = __webpack_public_path__ + "media/images/img-alchemist-39cfb6c112e7e7fcdd52f9f78b4c3a41.svg";